import script from "./DeleteJobConfirmDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteJobConfirmDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteJobConfirmDropdown.vue?vue&type=style&index=0&id=9d54a2ea&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d54a2ea"]])

export default __exports__